export type LatLon = { lat: number; lon: number };

export function haversine(a: LatLon, b: LatLon): number {
  const R = 6371e3; // meters
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lon - a.lon);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const sinDLat = Math.sin(dLat / 2);
  const sinDLon = Math.sin(dLon / 2);
  const h = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export function formatDistance(meters: number): string {
  if (!isFinite(meters)) return "-";
  if (meters < 1000) return `${Math.round(meters)}m`;
  return `${(meters / 1000).toFixed(meters < 10000 ? 1 : 0)}km`;
}

export async function getCurrentPosition(timeoutMs = 15000): Promise<LatLon> {
  if (typeof window === 'undefined' || !('geolocation' in navigator)) {
    throw new Error('位置情報が利用できません');
  }
  return new Promise((resolve, reject) => {
    const t = setTimeout(() => reject(new Error('位置情報の取得がタイムアウトしました')), timeoutMs);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(t);
        resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude });
      },
      (err) => {
        clearTimeout(t);
        reject(err);
      },
      { enableHighAccuracy: true, maximumAge: 60000, timeout: timeoutMs }
    );
  });
}

export async function geocodeText(q: string): Promise<LatLon | null> {
  try {
    const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&accept-language=ja&q=${encodeURIComponent(q)}`;
    const r = await fetch(url, { headers: { 'User-Agent': 'ccq-app/1.0' } });
    if (!r.ok) return null;
    const arr = await r.json();
    if (!Array.isArray(arr) || arr.length === 0) return null;
    const best = arr[0];
    const lat = parseFloat(best.lat);
    const lon = parseFloat(best.lon);
    if (isFinite(lat) && isFinite(lon)) return { lat, lon };
    return null;
  } catch {
    return null;
  }
}

